import React, { useMemo } from 'react';

import type { IResourceClientMember } from '@/api/types';
import type { IFormSelect } from './types';

import { Select } from './Select';

interface IProps extends IFormSelect {
  clientMemberList: IResourceClientMember[];
  metaData?: {
    createdByName: string;
    createdBy: number | string;
  };
}

const addMissingMember = (options: NonNullable<IFormSelect['options']>, metaData?: IProps['metaData']) => {
  if (metaData && !options.some(option => option.value === metaData.createdBy)) {
    return [{ label: metaData.createdByName, value: metaData.createdBy }, ...options];
  }

  return options;
};

const ClientMemberSelect = ({ clientMemberList, metaData, ...rest }: IProps): React.ReactElement => {
  const memberOptions = useMemo(() => {
    const options = clientMemberList.map(member => ({ value: member.userId, label: member.fullName }));
    return addMissingMember(options, metaData);
  }, [clientMemberList, metaData]);

  return <Select {...rest} options={memberOptions} />;
};

export { ClientMemberSelect };
